import React from 'react';
import PropTypes from 'prop-types';
import BEM from '../../bem';

import { mobxInjectSelect } from '../../utils';
import { ReactComponent as MemberAdded } from '../../images/green-checkmark.svg';
import { ReactComponent as MembersToBeAdded } from '../../images/check-add-members.svg';
import {
  Group,
  Individual,
  Role,
} from '../../../widgets/messenger/components/SearchSidebar/SearchParityResults';

const classes = BEM.with('ProviderSearchBoxResult');

const ProviderSearchBoxResult = ({
  currentOrganization,
  currentUserId,
  entityType,
  hideDnd,
  isUserDndAfEnabledForCurrentOrg,
  isFirstEntry,
  isPresenceFeatureFlagEnabled,
  pendingMemberIds,
  toggle,
  entity,
}) => {
  const isSelected = pendingMemberIds.some(
    (pendingMemberId) => pendingMemberId === entity.id || pendingMemberId === entity.botUserId
  );

  const userDndAfStatusForCurrentOrg = isUserDndAfEnabledForCurrentOrg(entity);

  return (
    <div>
      <div className={classes()} onClick={() => toggle(entity)}>
        <div className={classes('wrapper', { isFirstEntry, isSearchParity: true })}>
          <>
            {entityType === 'user' && (
              <Individual
                currentOrganization={currentOrganization}
                currentUserId={currentUserId}
                hideDnd={hideDnd}
                individual={entity}
                isPresenceFeatureFlagEnabled={isPresenceFeatureFlagEnabled}
                presenceSize={'small'}
                showDndAfStatus={userDndAfStatusForCurrentOrg}
                showPresenceIndicator={true}
                typeOfUser={'composeUser'}
              />
            )}
            {entityType === 'role' && <Role role={entity} />}
            {entityType === 'group' && <Group group={entity} />}
          </>
          <div className={classes('check-mark', { isSelected })}>
            {isSelected ? <MemberAdded /> : <MembersToBeAdded />}
          </div>
        </div>
      </div>
    </div>
  );
};

ProviderSearchBoxResult.propTypes = {
  isFirstEntry: PropTypes.bool,
  pendingMemberIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggle: PropTypes.func.isRequired,
  entity: PropTypes.object.isRequired,
};

ProviderSearchBoxResult.defaultProps = {
  isFirstEntry: false,
};

export default mobxInjectSelect({
  messengerStore: ['currentOrganization', 'isPresenceFeatureFlagEnabled'],
  sessionStore: ['currentUserId'],
  userStore: ['hideDnd', 'isUserDndAfEnabledForCurrentOrg'],
})(ProviderSearchBoxResult);
